import { Types } from '../actions/alertActions';

const initialState = {
  open: false,
  message: '',
  title: 'Bilgilendirme',
};

export const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_ALERT: {
      return {
        ...state,
        open: true,
        message: action.message,
        title: action.title || 'Bilgilendirme'
      };
    }
    case Types.CLOSE_ALERT: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};
